// import React from 'react'
import * as Yup from 'yup'
const mapValues = require('lodash/mapValues')

export const initialValues= {

  selected_plan: "",
  // promo_code: "",

  // Account Holder Details
  AH_first_name: "",
  AH_last_name: "",
  // AH_email: "",
  AH_phone: "",
  AH_DOB: "",
  AH_address: "",
  AH_city: "",
  AH_country: "",
  AH_province: "",
  AH_postal: "",

  teams: [],

  // Org Details
  org_name: "",
  org_website: "",
  org_instagram: "",
  org_social: "",
  org_address: "",
  org_city: "",
  org_country: "",
  org_province: "",
  org_postal: "",

  // Enrol Teams
  teams: '',
  
  // EF1
  // org_contact: "",
  org_phone: "",
  org_email: "",

  business_name: "",
  business_no: "",
  business_type: "",
  yr_est: "",
  annual_rev: "",
  mthly_sale: "",
  avg_tnx: "",
  max_tnx: "",
  upload_check: '',
  upload_id: '',
  agree_waver: false,
}

export const validationSchema= Yup.object({
  enrolInLeagues: Yup.boolean(),
  EF1: Yup.boolean(),
  // diffMailAddress: Yup.boolean(),
  // checkBox: Yup.boolean().oneOf([true]).required('Must Read and Accept Terms'),
  // checkBox: Yup.boolean().when('EF1', {
  //   is: false,
  //   then: Yup.boolean().oneOf([true]).required('Must Read and Accept Terms')
  // }),

  //selected_plan: Yup.string().required('Please select a plan'),
  
  selected_plan: Yup.string().when('EF1', {
    is: false,
    then: Yup.string().required('Please select a plan')
  }),

  // Account Holder Details - Only required for net new Hoopstir customers

  AH_first_name: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_last_name: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_phone: Yup.number().when('enrolInLeagues', {
    is: false,
    then: Yup.number().typeError('Please type number').required('Required field')
  }),
  // AH_email: Yup.string().when('EF1', {
  //   is: true,
  //   then: Yup.string().required('Required field')
  // }),
  //AH_DOB: Yup.string().required('Required field').nullable(),
  AH_DOB: Yup.date().typeError('Please add a valid date').required('Required field'),
  AH_address: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_city: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_country: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_province: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  AH_postal: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  // agree_waver: Yup.bool().when('enrolInLeagues', {
  //   is: false,
  //   then: Yup.bool().oneOf([true], 'Please confirm that you have read the waver.')
  // }),



  //teams: Yup.string().required('Please enrol at least one team'),
  teams: Yup.string().when('EF1', {
    is: false,
    then: Yup.string().required('Please enrol at least one team')
  }),

  // Required Organization Details - Only required for net new Hoopstir customers

  org_name: Yup.string().when('enrolInLeagues', {
    is: false,
    then: Yup.string().required('Required field')
  }),
  
  // EF1

  // AH_DOB: Yup.date().when('EF1', {
  //   is: true,
  //   then: Yup.date('Invalid date').required('Required field')
  // }),
  org_website: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  // org_contact: Yup.string().when('EF1', {
  //   is: true,
  //   then: Yup.string().required('Required field')
  // }),
  org_phone: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_email: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_address: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_city: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_country: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_province: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  org_postal: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),

  // Required Payment Details
  business_name: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  business_no: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  business_type: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  yr_est: Yup.string().when('EF1', {
    is: true,
    then: Yup.string().required('Required field')
  }),
  annual_rev: Yup.number().when('EF1', {
    is: true,
    then: Yup.number().typeError('Please type number').required('Required field')
  }),
  mthly_sale: Yup.number().when('EF1', {
    is: true,
    then: Yup.number().typeError('Please type number').required('Required field')
  }),
  avg_tnx: Yup.number().when('EF1', {
    is: true,
    then: Yup.number().typeError('Please type number').required('Required field')
  }),
  max_tnx: Yup.number().when('EF1', {
    is: true,
    then: Yup.number().typeError('Please type number').required('Required field')
  }),
  upload_check: Yup.mixed().when('EF1', {
    is: true,
    then: Yup.mixed().required('Please upload a file')
  }),
  upload_id: Yup.mixed().when('EF1', {
    is: true,
    then: Yup.mixed().required('Please upload a file')
  }),
})

// https://itnext.io/simple-react-form-validation-with-formik-yup-and-or-spected-206ebe9e7dcc